import { HttpApiError } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

/*
 * Send form for lost password
 */
export function useLostPassword() {
  async function lostPassword(email: string) {
    const $httpFetch = useHttpFetch()

    const body = { email }

    try {
      await $httpFetch('/auth/password-reset/start-flow', {
        method: 'POST',
        body,
      })

      return {
        error: null,
      }
    } catch (error) {
      return {
        error: error as HttpApiError,
      }
    }
  }

  return { lostPassword }
}
